/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './ServiceBenefits.scss';

import { isEmpty, isEqual } from 'lodash';
import { number, string } from 'prop-types';
import React, { Fragment } from 'react';

import { Link } from 'react-router-dom';
import ServiceBenefitsCard from './ServiceBenefitsCard';
import { allBenefitsUrl, serviceBenefitsConfig } from './ServiceBenefitsConfig';
import BaseCard from 'components/shared/Card/BaseCard';
import {
  ENHANCED_PERSONAL_SERVICE_TITLE,
  PERSONAL_SERVICE_TITLE,
  SERVICE_TYPE_MIL
} from 'services/ServiceBenefits';

const Footer = ({ benefitsUrl }) => {
  return (
    <Fragment>
      {benefitsUrl && (
        <div className="service-benefits-footer">
          {!benefitsUrl.includes('http') ? (
            <Link to={benefitsUrl}>View All</Link>
          ) : (
            <a href={benefitsUrl}>View All</a>
          )}
        </div>
      )}
    </Fragment>
  );
};

const TitleComponent = ({ serviceType }) => {
  let title = isEqual(serviceType, SERVICE_TYPE_MIL)
    ? ENHANCED_PERSONAL_SERVICE_TITLE
    : PERSONAL_SERVICE_TITLE;

  return (
    <div className="service-benefits-header-container">
      <span className="service-benefit-title">{title}</span>
    </div>
  );
};

const ServiceBenefits = ({ data, isLoading, hasError }) => {
  const { serviceType } = data;
  const configs = serviceBenefitsConfig(serviceType);
  if (isEmpty(configs) || hasError) {
    return null;
  }

  const benefitsUrl = allBenefitsUrl(serviceType);

  return (
    <BaseCard
      isLoading={isLoading}
      title={<TitleComponent serviceType={serviceType} />}
      footer={<Footer benefitsUrl={benefitsUrl} />}
      className="standard service-benefits module-container">
      <div className="service-benefits-cards">
        {configs.map((config, i) => (
          <ServiceBenefitsCard key={i} config={config} />
        ))}
      </div>
    </BaseCard>
  );
};

ServiceBenefits.propTypes = {
  serviceLevel: string,
  serviceType: number
};

export default ServiceBenefits;
